import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type PromptSidebarModule = 'all' | 'liked' | 'publish' | 'generate'

export interface PromptSidebarState {
  /** 每个笔记的侧边栏开/关状态（按 noteId 维度独立控制） */
  openByNoteId: Record<string, boolean>
  width: number
  activeModule: PromptSidebarModule
  /** 每个笔记的自动生成标志（按 noteId 维度独立控制） */
  autoGenerateByNoteId: Record<string, boolean>
}

const initialState: PromptSidebarState = {
  openByNoteId: {},
  width: 400,
  activeModule: 'all',
  autoGenerateByNoteId: {},
}

const promptSidebarSlice = createSlice({
  name: 'promptSidebar',
  initialState,
  reducers: {
    openPromptSidebar: (state, action: PayloadAction<string>) => {
      state.openByNoteId[action.payload] = true
    },
    closePromptSidebar: (state, action: PayloadAction<string>) => {
      state.openByNoteId[action.payload] = false
    },
    togglePromptSidebar: (state, action: PayloadAction<string>) => {
      const noteId = action.payload
      state.openByNoteId[noteId] = !state.openByNoteId[noteId]
    },
    setPromptSidebarWidth: (state, action: PayloadAction<number>) => {
      state.width = action.payload
    },
    setPromptSidebarActiveModule: (state, action: PayloadAction<PromptSidebarModule>) => {
      state.activeModule = action.payload
    },
    /** 触发自动生成：打开侧边栏 + 切换到生成模块 + 设置标志 */
    triggerAutoGenerate: (state, action: PayloadAction<string>) => {
      const noteId = action.payload
      state.openByNoteId[noteId] = true
      state.activeModule = 'generate'
      state.autoGenerateByNoteId[noteId] = true
    },
    /** 清除自动生成标志（生成模块消费后调用） */
    clearAutoGenerate: (state, action: PayloadAction<string>) => {
      state.autoGenerateByNoteId[action.payload] = false
    },
  },
})

export const {
  openPromptSidebar,
  closePromptSidebar,
  togglePromptSidebar,
  setPromptSidebarWidth,
  setPromptSidebarActiveModule,
  triggerAutoGenerate,
  clearAutoGenerate,
} = promptSidebarSlice.actions

export default promptSidebarSlice.reducer
